import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import Popup from "../../../ResuableCompoment/Popup";
import { Plus, Minus } from "lucide-react";
import { fetchWalletBalance, fetchSettlementBalance, fetchAepsBalance } from "../../../Store/Slices/WalletSlice";

const Settlement1FundTransfer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { selectedBeneficiary = [], amount = 0 } = location.state || {};
    const beneficiary = selectedBeneficiary[0];
    const { lat, lng, status } = useSelector((s) => s.location);
    const latitude = lat;
    const longitude = lng;


    const remitterMobile = useSelector(
        (state) => state.auth.remitterData?.remitter_phone
    );

    const username = useSelector(
        (state) => state.auth.employeeDetails?.username
    );

    /* ---------------- GEO LOCATION (SAME AS AEPS SETTLEMENT) ---------------- */
    const [mpin, setMpin] = useState("");
    const mpinRefs = React.useRef([]);


    const [shouldRedirect, setShouldRedirect] = useState(true);



    const [fee, setFee] = useState(0);
    const [txnAmount, setTxnAmount] = useState(0); // ✅ from fee API
    const [totalAmount, setTotalAmount] = useState(0);
    const [loadingFee, setLoadingFee] = useState(false);

    /* ---------------- UI STATE ---------------- */
    const [isLoading, setIsLoading] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [isTermsAccepted, setIsTermsAccepted] = useState(false);
    const [showTermsDetails, setShowTermsDetails] = useState(false);
    const [showBreakdown, setShowBreakdown] = useState(false);

    const [ipAddress, setIpAddress] = useState("");


    const { callApi: calculateFee } = useApi("/dmt/fee/calculate/aeps/settle", "POST");
    const { callApi: payout } = useApi("/payout/single/payout", "POST");

    useEffect(() => {
        fetch("https://api.ipify.org?format=json")
            .then((r) => r.json())
            .then((d) => setIpAddress(d.ip || ""))
            .catch(() => setIpAddress(""));
    }, []);

    /* ---------------- FEE CALCULATION ---------------- */
    useEffect(() => {
        const calculateCharges = async () => {
            if (!amount || Number(amount) <= 0) return;

            setLoadingFee(true);

            try {
                const payload = {
                    paymentMode: "IMPS",
                    provider: "SETTLEMENT",
                    sub_provider: "NIFI",
                    amount: Number(amount),
                    commercial_type: "TRANSACTION_FEE",
                    mid: username
                };

                const res = await calculateFee(payload);

                const calculatedFee = Number(res?.fee || 0);
                const calculatedTxnAmount =
                    Number(res?.txn_amount) || Number(amount) + calculatedFee;

                setFee(calculatedFee);
                setTxnAmount(calculatedTxnAmount); // ✅ IMPORTANT
                setTotalAmount(calculatedTxnAmount);
            } catch (err) {
                setFee(0);
                setTxnAmount(Number(amount));
                setTotalAmount(Number(amount));
            } finally {
                setLoadingFee(false);
            }
        };

        calculateCharges();
    }, [amount]);

    const isValidEmail = (email) => {
        if (!email) return false;
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    };

    const handleMpinChange = (index, value) => {
        if (!/^[0-9]?$/.test(value)) return;

        const newMpin = mpin.split("");
        newMpin[index] = value;
        const updated = newMpin.join("");
        setMpin(updated);

        // Auto focus next
        if (value && index < 5) {
            mpinRefs.current[index + 1].focus();
        }
    };

    const handleMpinBackspace = (index, e) => {
        if (e.key === "Backspace" && !mpin[index] && index > 0) {
            mpinRefs.current[index - 1].focus();
        }
    };


    /* ---------------- PAYOUT ---------------- */
    // const handleTransferAmount = async () => {
    //     if (!latitude || !longitude) {
    //         setPopupMessage("Please enable location access to proceed.");
    //         setPopupType("error");
    //         setShowPopup(true);
    //         return;
    //     }
    //     if (!mpin || mpin.length !== 6) {
    //         setPopupMessage("Enter MPIN required");
    //         setPopupType("error");
    //         setShowPopup(true);
    //         return;
    //     }


    //     setIsLoading(true);

    //     try {
    //         const payload = {
    //             mid: username,
    //             beneficiary_account_number: beneficiary.accountNo,
    //             beneficiary_ifsc_code: beneficiary.ifscCode,
    //             beneficiary_name: beneficiary.beneficiaryName,
    //             beneficiary_mobile: beneficiary.beneficiaryMobileNumber,
    //             beneficiary_email: "info@bingopays.in",
    //             beneficiary_bank_name: beneficiary.bankName,
    //             paymentMode: "IMPS",
    //             netAmount: Number(amount),
    //             txnAmount: txnAmount,
    //             lat: latitude,
    //             lng: longitude,
    //             customer_mobile: beneficiary.remitterMobileNumber,
    //             mpin: mpin,
    //         };

    //         const res = await payout(payload);

    //         const status = res?.status || "FAILED";
    //         const message = res?.message || "Transaction failed";
    //         const utr = res?.utr || "NA";

    //         if (status === "SUCCESS") {
    //             const lines = [];

    //             // Title
    //             lines.push("✅ Transaction Completed Successfully");
    //             lines.push("");

    //             // Amount
    //             lines.push(`Amount: ₹${Number(res.amount).toFixed(2)}`);

    //             // Beneficiary name
    //             lines.push(`Beneficiary: ${res.beneficiaryName}`);

    //             // Beneficiary account
    //             lines.push(`Account: ${res.beneficiaryAccount}`);

    //             // UTR
    //             lines.push(`UTR: ${res.utr}`);

    //             setPopupMessage(lines.join("\n"));
    //             setPopupType("success");
    //             setShowPopup(true);
    //             return;
    //         }

    //         if (status === "PENDING") {
    //             const lines = [];

    //             // Title
    //             lines.push("✅ Transaction Processed Successfully");
    //             lines.push("");

    //             // Amount
    //             lines.push(`Amount: ₹${Number(res.amount).toFixed(2)}`);

    //             // Beneficiary name
    //             lines.push(`Beneficiary: ${res.beneficiaryName}`);

    //             // Beneficiary account
    //             lines.push(`Account: ${res.beneficiaryAccount}`);

    //             // UTR
    //             // lines.push(`UTR: ${res.utr}`);

    //             setPopupMessage(lines.join("\n"));
    //             setPopupType("success");
    //             setShowPopup(true);
    //             return;
    //         }

    //         if (status === "GGGGGG") {
    //             setPopupMessage(`⏳ ${message}`);
    //             setPopupType("pending"); // if Popup supports warning
    //             setShowPopup(true);
    //             return;
    //         }
    //         setPopupMessage(`${message}`);
    //         setPopupType("error");
    //         setShowPopup(true);
    //     } catch (err) {
    //         setPopupMessage(err.message || "Payout failed");
    //         setPopupType("error");
    //         setShowPopup(true);
    //     } finally {
    //         setIsLoading(false);
    //         dispatch(fetchWalletBalance());
    //         dispatch(fetchAepsBalance());
    //         dispatch(fetchSettlementBalance());
    //     }
    // };

    /* ---------------- PAYOUT ---------------- */
    const handleTransferAmount = async () => {
        if (!latitude || !longitude) {
            setPopupMessage("Please enable location access to proceed.");
            setPopupType("error");
            setShowPopup(true);
            return;
        }
        if (!mpin || mpin.length !== 6) {
            setPopupMessage("Enter MPIN required");
            setPopupType("error");
            setShowPopup(true);
            return;
        }


        setIsLoading(true);
        setShouldRedirect(true); // ✅ Reset to true on new attempt

        try {
            const payload = {
                mid: username,
                beneficiary_account_number: beneficiary.accountNo,
                beneficiary_ifsc_code: beneficiary.ifscCode,
                beneficiary_name: beneficiary.beneficiaryName,
                beneficiary_mobile: beneficiary.beneficiaryMobileNumber,
                beneficiary_email: "info@bingopays.in",
                beneficiary_bank_name: beneficiary.bankName,
                paymentMode: "IMPS",
                netAmount: Number(amount),
                txnAmount: txnAmount,
                lat: latitude,
                lng: longitude,
                customer_mobile: beneficiary.remitterMobileNumber,
                mpin: mpin,
                ipAddress: ipAddress,
            };

            const res = await payout(payload);

            // ✅ NEW: Handle Invalid MPIN specifically to prevent redirection
            if (res?.error_code === "DMT050" || res?.message === "Invaild MPIN" || res?.message === "Invalid MPIN") {
                setPopupMessage(res.message || "Invalid MPIN");
                setPopupType("error");
                setShouldRedirect(false); // Prevent redirect
                setShowPopup(true);
                return;
            }

            const status = res?.status || "FAILED";
            const message = res?.message || "Transaction failed";
            const utr = res?.utr || "NA";

            if (status === "SUCCESS") {
                const lines = [];
                lines.push("✅ Transaction Completed Successfully");
                lines.push("");
                lines.push(`Amount: ₹${Number(res.amount).toFixed(2)}`);
                lines.push(`Beneficiary: ${res.beneficiaryName}`);
                lines.push(`Account: ${res.beneficiaryAccount}`);
                lines.push(`UTR: ${res.utr}`);

                setPopupMessage(lines.join("\n"));
                setPopupType("success");
                setShowPopup(true);
                return;
            }

            if (status === "PENDING") {
                const lines = [];
                lines.push("✅ Transaction Processed Successfully");
                lines.push("");
                lines.push(`Amount: ₹${Number(res.amount).toFixed(2)}`);
                lines.push(`Beneficiary: ${res.beneficiaryName}`);
                lines.push(`Account: ${res.beneficiaryAccount}`);

                setPopupMessage(lines.join("\n"));
                setPopupType("success");
                setShowPopup(true);
                return;
            }

            if (status === "GGGGGG") {
                setPopupMessage(`⏳ ${message}`);
                setPopupType("pending"); 
                setShowPopup(true);
                return;
            }
            
            setPopupMessage(`${message}`);
            setPopupType("error");
            setShowPopup(true);
        } catch (err) {
            // ✅ NEW: Catch Invalid MPIN if it throws as an error
            if (err?.error_code === "DMT050" || err?.message === "Invaild MPIN" || err?.message === "Invalid MPIN") {
                setShouldRedirect(false); // Prevent redirect
            } else {
                setShouldRedirect(true);
            }

            setPopupMessage(err.message || "Payout failed");
            setPopupType("error");
            setShowPopup(true);
        } finally {
            setIsLoading(false);
            dispatch(fetchWalletBalance());
            dispatch(fetchAepsBalance());
            dispatch(fetchSettlementBalance());
        }
    };

    if (!beneficiary) {
        return (
            <div className="p-6 text-center text-red-600">
                Invalid access. Please start from AEPS Remitter.
            </div>
        );
    }

    return (
        // <div className="max-w-4xl mx-auto mt-10 bg-white rounded-3xl shadow-lg p-8">
        <div className="max-w-[95%] mx-auto  bg-white rounded-3xl shadow-lg px-5 py-2">
            <h2 className="text-2xl font-semibold mb-2 text-slate-800">
                AEPS Fund Transfer
            </h2>

            {/* BENEFICIARY */}
            {/* <div className="mb-6 border rounded-xl p-4 2xl:p-6 min-[2000px]:p-8 bg-slate-50"> */}
            <div className="mb-2 border rounded-xl p-2 2xl:p-6 min-[2000px]:p-8 bg-slate-50">
                <h3 className="text-lg 2xl:text-xl min-[2000px]:text-2xl font-semibold text-slate-700 mb-3">
                    Beneficiary Details
                </h3>

                <div className="text-base 2xl:text-xl min-[2000px]:text-2xl space-y-1 2xl:space-y-2">
                    <div className="flex justify-between">
                        <span className="font-semibold">Name:</span>
                        <span className="font-semibold">{beneficiary.beneficiaryName}</span>
                    </div>

                    <div className="flex justify-between">
                        <span className="font-semibold">Account No:</span>
                        <span className="text-lg 2xl:text-xl min-[2000px]:text-3xl font-bold text-red-600 tracking-normal sm:tracking-widest " >{beneficiary.accountNo}</span>
                    </div>

                    <div className="flex justify-between">
                        <span className="font-semibold">IFSC:</span>
                        <span className="font-semibold">{beneficiary.ifscCode}</span>
                    </div>

                    <div className="flex justify-between">
                        <span className="font-semibold">Bank:</span>
                        <span className="font-semibold ">{beneficiary.bankName}</span>
                    </div>
                </div>
            </div>

            {/* BREAKDOWN */}
            <div className="border rounded-xl p-4 2xl:p-6 min-[2000px]:p-8 bg-slate-50">
                <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={() => setShowBreakdown(!showBreakdown)}
                >
                    <h3 className="text-lg 2xl:text-xl min-[2000px]:text-2xl font-semibold text-slate-700">
                        Amount Breakdown
                    </h3>

                    <button
                        type="button"
                        className="w-8 h-8 flex items-center justify-center rounded-full border bg-white text-xl font-bold"
                    >
                        {showBreakdown ? <Minus size={18} /> : <Plus size={18} />}
                    </button>
                </div>

                <div className="mt-4 space-y-2 text-base 2xl:text-lg min-[2000px]:text-2xl font-semibold">
                    {/* Always Visible */}
                    <div className="flex justify-between">
                        <span>Transfer Amount</span>
                        <span className="font-extrabold text-2xl 2xl:text-3xl min-[2000px]:text-5xl text-green-600">
                            ₹ {Number(amount).toFixed(2)}
                        </span>
                    </div>

                    {/* Hidden by default */}
                    {showBreakdown && (
                        <>
                            <div className="flex justify-between">
                                <span>Charges</span>
                                <span>₹ {fee.toFixed(2)}</span>
                            </div>

                            <div className="flex justify-between font-bold pt-2 border-t">
                                <span>Total Debit</span>
                                <span className="text-green-600 text-[25px] font-bold">
                                    ₹ {totalAmount.toFixed(2)}
                                </span>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* MPIN INPUT */}
            <div className="mt-6">
                <label className="text-sm font-medium text-slate-700">
                    Enter MPIN <span className="text-red-500">*</span>
                </label>

                <div className="flex gap-1 sm:gap-3 mt-2">
                    {[...Array(6)].map((_, i) => (
                        <input
                            key={i}
                            ref={(el) => (mpinRefs.current[i] = el)}
                            type="password"
                            maxLength={1}
                            value={mpin[i] || ""}
                            onChange={(e) => handleMpinChange(i, e.target.value)}
                            onKeyDown={(e) => {
                                // 1. Keep your existing backspace logic
                                handleMpinBackspace(i, e);

                                // 2. Add the Enter key logic
                                if (e.key === 'Enter') {
                                    e.preventDefault();

                                    // ✅ FIX: Added `!showPopup` so it won't fire if the popup is on screen
                                    if (!isLoading && !loadingFee && isTermsAccepted && !showPopup) {
                                        handleTransferAmount();
                                    }
                                }
                            }}
                            className="w-12 h-12 text-center text-xl border-2 border-slate-800 rounded-lg focus:border-indigo-600 outline-none "
                        />
                    ))}
                </div>
            </div>

            {/* TERMS AND CONDITIONS */}
            <div className="mt-6 flex items-center gap-2 bg-slate-50 p-3 rounded-xl border border-slate-200">
                <input
                    type="checkbox"
                    id="terms"
                    checked={isTermsAccepted}
                    onChange={(e) => setIsTermsAccepted(e.target.checked)}
                    onKeyDown={(e) => {
                        // ✅ FIX: Allow Enter key to submit, with full safety locks
                        if (e.key === 'Enter') {
                            e.preventDefault();

                            // Note: Using isLoading and showPopup to match this component's exact state names
                            if (!isLoading && !loadingFee && isTermsAccepted && !showPopup) {
                                handleTransferAmount();
                            }
                        }
                    }}
                    className="w-5 h-5 cursor-pointer accent-[#12345A]"
                />
                <label htmlFor="terms" className="text-sm sm:text-base text-slate-700 cursor-pointer select-none">
                    I have read, understood, and agree to BingoPay's Transactional {" "}
                    <button
                        type="button"
                        onClick={() => setShowTermsDetails(true)}
                        className="text-indigo-600 font-bold hover:underline"
                    >
                        Declaration and Disclaimer
                    </button>
                </label>
            </div>

            <div className="flex justify-end mt-6">
                <button
                    onClick={handleTransferAmount}
                    // ✅ FIX: Added `showPopup` to the disabled conditions
                    disabled={isLoading || loadingFee || !isTermsAccepted || showPopup}
                    className={`px-10 py-4 rounded-2xl font-semibold text-white transition-all duration-300
    ${(isLoading || loadingFee || !isTermsAccepted || showPopup)
                            ? "bg-slate-300 text-slate-500 cursor-not-allowed pointer-events-none opacity-80"
                            : "bg-[#12345A] hover:bg-[#1a4a80] hover:shadow-xl active:scale-95"
                        }`}
                >
                    {isLoading ? "Processing..." : "Transfer Amount"}
                </button>
            </div>

            {/* {showPopup && (
                <Popup
                    message={popupMessage}
                    type={popupType}
                    navigateTo="/transactionhistory"
                    onClose={() => {
                        setShowPopup(false);
                        navigate("/transactionhistory")
                    }}
                    showchildren={false}
                />
            )} */}
            {showPopup && (
                <Popup
                    message={popupMessage}
                    type={popupType}
                    navigateTo={shouldRedirect ? "/aepssettlement1" : undefined}
                    onClose={() => {
                        setShowPopup(false);
                        
                        if (shouldRedirect) {
                            navigate("/aepssettlement1");
                        } else {
                            // ✅ Stay on page, clear MPIN, and refocus the first input box for quick retry
                            setMpin(""); 
                            if (mpinRefs.current && mpinRefs.current[0]) {
                                mpinRefs.current[0].focus();
                            }
                        }
                    }}
                    showchildren={false}
                />
            )}



            {/* DETAILED TERMS MODAL */}
            {showTermsDetails && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4 ">
                    <div className="bg-white w-full max-w-5xl rounded-2xl shadow-2xl flex flex-col max-h-[90vh]">
                        <div className="p-4 border-b flex justify-between items-center bg-slate-50">
                            <h3 className="font-bold text-lg">TRANSACTIONAL DECLARATION</h3>
                            <button onClick={() => setShowTermsDetails(false)} className="text-2xl">&times;</button>
                        </div>

                        <div className="p-6 overflow-y-auto text-sm text-slate-600 leading-relaxed">
                            <p className="mb-4 font-bold text-slate-800">By ticking the checkbox below and proceeding with this payment, I (the "User") hereby confirm, declare, and agree to the following representations and warranties in favour of BingoPay (ShreeBalaJee Connect Pvt. Ltd.), unconditionally and without reservation, in relation to this transaction and each future transaction I conduct through BingoPay's platform:</p>
                            <ul className="list-decimal pl-5 space-y-2">
                                <li>I confirm and represent that the funds used or to be used in this transaction are not derived from, connected to, or intended for use in any money laundering activity, as defined under the Prevention of Money Laundering Act, 2002 ("PMLA") or any other applicable law or regulation in force in India or any other jurisdiction. I have not engaged in, and do not intend to engage in, any activity that constitutes money laundering under applicable law..</li>

                                <li>I confirm that the funds being used in this transaction are:
                                    (a) legitimately earned and/or obtained from a lawful source;
                                    (b) entirely my own funds, or funds over which I hold a valid and lawful authority or mandate to transact;
                                    (c) not sourced, directly or indirectly, from any criminal, illegal, fraudulent, or unauthorised activity; and
                                    (d) not the proceeds of any offence under applicable Indian law or the law of any other jurisdiction.</li>

                                <li>I confirm that all personal and transactional information provided in connection with this payment, including my identity, contact, billing, payment instrument details, and transaction purpose, is true, accurate, current, and complete. I acknowledge that providing any false, misleading, or incomplete information may constitute an offence under applicable Indian laws, including the Information Technology Act, 2000 and the Bharatiya Nyaya Sanhita, 2023, and may result in suspension or termination of access to BingoPay’s platform and/or referral to law enforcement authorities.</li>

                                <li>I confirm that the purpose of this transaction is entirely lawful. The goods and/or services being purchased, or the purpose of payment being made, do not violate any applicable law, regulation, or governmental directive in India or any other jurisdiction. I am not using BingoPay's services to purchase, obtain, or facilitate access to any goods, services, or content that is prohibited, restricted, or illegal under applicable law.</li>

                                <li>I confirm that the funds being transmitted through this transaction are not connected to, and will not be used for, any act of terrorism, terrorist financing, or the support of any terrorist organisation or individual, as defined under the Unlawful Activities (Prevention) Act, 1967, the PMLA 2002, or any other applicable law. I am not acting on behalf of, or for the benefit of, any person or entity engaged in or associated with terrorist activity.</li>
                                <li>I confirm that; (a) I am an individual of 18 years of age or older, with full legal capacity and authority to enter into this Declaration, to make this payment, and to be bound by the terms hereof. If transacting on behalf of another person or entity, I hold a valid and subsisting authority (including, where required, a power of attorney or board resolution) to do so (b) the payment instrument (including debit card, credit card, prepaid card, UPI handle, net banking credentials, digital wallet, or any other mode of payment) used for this transaction is registered in my name and/or I am the duly authorised holder or user of such instrument. I am not using any stolen, compromised, fraudulently obtained, or unauthorised payment instrument, and I have not obtained or used any other person's payment instrument without their knowledge and consent.</li>
                                <li>I confirm that I am not: (a) a person or entity listed on any sanctions list maintained by the Government of India, the Reserve Bank of India, the United Nations Security Council, or any other competent authority; (b) resident in or transacting from a comprehensively sanctioned jurisdiction under Indian or international law; or (c) transacting for the direct or indirect benefit of any sanctioned person or entity.</li>
                                <li>I confirm that I am in compliance with all applicable laws, rules, and regulations, including the Payment and Settlement Systems Act, 2007, the Information Technology Act, 2000, the Consumer Protection Act, 2019, and all applicable RBI regulations in relation to this transaction.</li>
                                <li>I consent to BingoPay collecting, storing, using, and processing my personal and transactional data for: (a) processing this transaction; (b) complying with KYC, AML, CFT, and other legal and regulatory obligations, including applicable RBI directions; (c) fraud detection and risk assessment; and (d) reporting to competent authorities as required by law, in accordance with BingoPay’s Privacy Policy and the Digital Personal Data Protection Act, 2023.</li>
                                <li>Where I authorise a recurring, standing, or mandate-based payment through BingoPay’s platform (including debit card, credit card, prepaid instrument, or UPI auto-pay), I acknowledge that: (a) such authorisation is provided voluntarily and constitutes my express consent for recurring transactions under the RBI’s Digital Payments – E-mandate Framework, 2026; (b) BingoPay and/or the acquirer bank will issue a pre-debit notification within the timeline prescribed by the RBI prior to each debit; (c) I may revoke or modify the mandate at any time through BingoPay’s platform or my bank/issuer; and (d) recurring transactions are subject to mandate registration, applicable limits, and authentication requirements prescribed under the E-mandate Framework.</li>
                            </ul>
                            <p className="font-bold  py-3 text-slate-800">
                                I acknowledge that BingoPay is a regulated payment aggregator subject to reporting obligations under the PMLA 2002 and the RBI (Regulation of Payment Aggregators) Directions, 2025 (effective September 15, 2025)I consent to BingoPay: (a) reporting my transaction to FIU-IND or any other competent regulatory or law enforcement authority if identified or reasonably suspected as a Suspicious Transaction or Reportable Transaction; (b) withholding, delaying, blocking, or reversing any payment pending verification or investigation; and (c) disclosing my transaction data and personal information to regulatory or law enforcement authorities to the extent required by law. BingoPay reserves the right to revise this Declaration at any time. The revised version shall be effective upon publication. Continued use of the platform after such revision constitutes acceptance of the updated Declaration.
                            </p>

                            <p className="font-bold  py-3 text-slate-800">I acknowledge that BingoPay reserves the right, at its sole discretion and without prior notice or liability, to decline, delay, hold, freeze, or reverse any transaction -- including where: (a) BingoPay reasonably suspects a violation of this Declaration or applicable law; (b) the transaction triggers AML/CFT risk indicators; (c) a competent authority directs BingoPay to do so; or (d) BingoPay's fraud detection systems identify the transaction as suspicious or high-risk.</p>
                            <p className="font-bold mb-4 pt-3 text-slate-800">
                                (AS A CHECK BOX AND USERS CAN PROCEED ONLY AFTER SELECTING ALL)
                                I have read, understood, and agree to BingoPay's Transactional Declaration and Disclaimer. I confirm that: (i) the funds used in this transaction are from a legitimate and lawful source; (ii) this transaction is for a lawful purpose only; (iii) I am not engaged in any money laundering, terrorist financing, or other unlawful activity; (iv) all information provided by me is true, accurate, and complete; and (v) I am the authorised user of the payment instrument being used. I consent to BingoPay processing my transaction data and reporting to regulatory authorities as required by applicable law.
                            </p>
                        </div>

                        <div className="p-4 border-t bg-slate-50 flex justify-end">
                            <button
                                onClick={() => {
                                    setIsTermsAccepted(true);
                                    setShowTermsDetails(false);
                                }}
                                className="bg-[#12345A] text-white px-6 py-2 rounded-xl font-semibold"
                            >
                                I Understand & Accept
                            </button>
                        </div>
                    </div>
                </div>
            )}



        </div>



    );
};

export default Settlement1FundTransfer;
